import { createContext } from 'react';

import { IBDUniFiDevice } from '@totem/components/ubiquiti/types';

interface Context {
  loading: boolean;
  error: boolean;
  deviceDetails: IBDUniFiDevice | null;
}

export default createContext<Context>({
  loading: false,
  error: false,
  deviceDetails: null,
});
